import ClipboardJS from 'clipboard';

const Util = {
	UpdateUrlHash(hash) {
		// make sure we're dealing with a good hash
		if (typeof hash !== 'undefined') {
			// ensure consistency
			if (hash.indexOf('#') < 0) {
				// eslint-disable-next-line no-param-reassign
				hash = `#${hash}`;
			}

			if (window.history.pushState) {
				window.history.pushState(null, null, hash);
			} else {
				window.location.hash = hash;
			}
		}
	},
	Clipboard() {
		const copyBtnSelector = '.btn-copy-text';

		$(copyBtnSelector)
			.tooltip({
				placement: 'top',
				title: 'Copied!',
				trigger: 'manual'
			})
			.on('mouseout', () => {
				$(this).tooltip('hide');
			});

		const clipboard = new ClipboardJS(copyBtnSelector);

		clipboard.on('success', e => {
			const $btn = $(e.trigger);
			$btn.tooltip('show');
			$(copyBtnSelector).blur();
			document.getSelection().removeAllRanges();
			setTimeout(() => {
				$btn.tooltip('hide');
			}, 2000);
		});
	}
};

export default Util;
